export enum SimpleTimeLineStatus {
    History = "History",
    Current = "Current",
    Future = "Future"
}

export const SIMPLE_TIMELINE_POINT_SIZE = 12;
export const SIMPLE_TIMELINE_POINT_MARGIN = 16;